import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7fbadfc9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_carousel = _resolveComponent("a-carousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_carousel, {
    "dots-class": "dot",
    autoplay: true,
    autoplaySpeed: 5000
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeService.banner, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.type,
          class: "img-container"
        }, [_createElementVNode("div", {
          class: "img-box",
          style: _normalizeStyle("background-image: url(".concat(item.banner, ")")),
          onClick: function ($event) {
            return _ctx.onBannerClick(item);
          }
        }, null, 12, _hoisted_2)]);
      }), 128))];
    }),
    _: 1
  })]);
}